// src/Home.js
import React, { useEffect, useState, useRef } from 'react';
import Swiper from 'swiper';
import { Carousel } from "../Components/carousel";
import '../assets/vendor/bootstrap/css/bootstrap.min.css';
import '../assets/vendor/bootstrap-icons/bootstrap-icons.css';
import '../assets/vendor/boxicons/css/boxicons.min.css';
import '../assets/vendor/glightbox/css/glightbox.min.css';
import '../assets/vendor/remixicon/remixicon.css';
import '../assets/vendor/swiper/swiper-bundle.min.css';
import '../assets/css/style.css';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../assets/vendor/bootstrap-icons/bootstrap-icons.css';
import Chatbot from './Chatbot'; // Import the Chatbot component
// import Image from "next/image";

import { BiBookReader, BiUserCircle, BiStar, BiBuildingHouse, BiBriefcaseAlt, BiWorld, BiAward } from "react-icons/bi";

// Import all images (unchanged)
import logoImg from '../assets/img/logof.png';
import passionBotAvatar from '../assets/img/avatar.png';
import upcomingEventImg from '../assets/img/blog/upcoming.png';
import schoolImg from '../assets/img/blog/scl2.jpg';
import mapImg from '../assets/img/logd back.png';
import testimonial1 from '../assets/img/testimonials/t1.png';
import testimonial2 from '../assets/img/testimonials/t2.png';
import testimonial3 from '../assets/img/testimonials/t3.png';
import testimonial4 from '../assets/img/testimonials/t4.jpeg';
import testimonial5 from '../assets/img/testimonials/t5.jpeg';
import { ContactUs } from './form';

const Home = () => {
  const [isLoading, setIsLoading] = useState(true); // Loading state for rocket animation
  const [isChatbotOpen, setIsChatbotOpen] = useState(false); // State for toggling chatbot
  const [mobileNavOpen, setMobileNavOpen] = useState(false); // Mobile navbar state
  const [mobileProjectsOpen, setMobileProjectsOpen] = useState(false);
  const [mobileEventsOpen, setMobileEventsOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0); // State for carousel
  // UGC form state
  const [locationType, setLocationType] = useState('');
  const [fieldOfInterest, setFieldOfInterest] = useState('');
  const [country, setCountry] = useState('');
  const [showScholarshipForm, setShowScholarshipForm] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const formRef = useRef(null);

  const loadScript = (src) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
    return script;
  };

  const scripts = [
    '/assets/vendor/purecounter/purecounter_vanilla.js',
    '/assets/vendor/aos/aos.js',
    '/assets/vendor/glightbox/js/glightbox.min.js',
    '/assets/vendor/isotope-layout/isotope.pkgd.min.js',
    '/assets/vendor/swiper/swiper-bundle.min.js',
    '/assets/js/main.js',
    'https://cdn.emailjs.com/dist/email.min.js',
  ];

  useEffect(() => {
    const loadedScripts = scripts.map(loadScript);
    // Initialize EmailJS when SDK is ready
    const initInterval = setInterval(() => {
      if (window.emailjs) {
        try { window.emailjs.init('bLrjqcmof3kc1CqMo'); } catch {}
        clearInterval(initInterval);
      }
    }, 200);
    return () => {
      loadedScripts.forEach(script => document.body.removeChild(script));
      clearInterval(initInterval);
    };
  }, []);

  // Set favicon to the FLRDF logo
  useEffect(() => {
    try {
      const existing = document.querySelector("link[rel='icon']");
      const link = existing || document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      link.href = mapImg; // '../assets/img/logd back.png'
      if (!existing) document.head.appendChild(link);
    } catch {}
  }, []);

  // Ensure hero is visible on initial load and handle loading animation
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    
    // Hide loading animation after 6 seconds
    const loadingTimer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(loadingTimer);
  }, []);

  const carouselSlides = [
    {
      src: "../assets/img/main.png",
    },
    {
      src: "../assets/img/main.png",
    },
  ];

  // Partner logos served from public/assets/img/Logos (G1-G6 first, then others)
  const partnerLogos = [
    'G1.jpeg','G2.jpg','G3.jpg','G4.png','G5.png','G6.png',
    '1.png','2.png','3.png','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg',
    '11.png','12.png','13.jpeg','14.png','15.png','16.png','17.jpg','18.png','19.jpg','20.png',
    '21.png','22.png','23.png','25.jpg','26.png','28.png','29.png','31.jpeg','32.jpeg','33.jpeg'
  ];

  // Toggle chatbot visibility
  const toggleChatbot = () => {
    setIsChatbotOpen(!isChatbotOpen);
  };

  const toggleMobileNav = () => {
    setMobileNavOpen((prev) => !prev);
    setMobileProjectsOpen(false);
    setMobileEventsOpen(false);
  };

  // Carousel functions
  const changeSlide = (direction) => {
    const slides = document.querySelectorAll('.carousel-slide');
    const indicators = document.querySelectorAll('.indicator');
    
    slides[currentSlide].classList.remove('active');
    if (indicators.length) indicators[currentSlide].classList.remove('active');
    
    let newSlide = currentSlide + direction;
    if (newSlide >= slides.length) newSlide = 0;
    if (newSlide < 0) newSlide = slides.length - 1;
    
    setCurrentSlide(newSlide);
    slides[newSlide].classList.add('active');
    if (indicators.length) indicators[newSlide].classList.add('active');
  };

  const goToSlide = (slideIndex) => {
    const slides = document.querySelectorAll('.carousel-slide');
    const indicators = document.querySelectorAll('.indicator');
    
    slides[currentSlide].classList.remove('active');
    if (indicators.length) indicators[currentSlide].classList.remove('active');
    
    setCurrentSlide(slideIndex);
    slides[slideIndex].classList.add('active');
    if (indicators.length) indicators[slideIndex].classList.add('active');
  };

  // Auto-play carousel
  useEffect(() => {
    const interval = setInterval(() => {
      changeSlide(1);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [currentSlide]);

  // UGC form helpers
  const resetFeedback = () => { setSuccessMsg(''); setErrorMsg(''); };
  const handleLocationTypeChange = (e) => {
    const value = e.target.value;
    setLocationType(value);
    setFieldOfInterest('');
    setCountry('');
    setShowScholarshipForm(false);
    resetFeedback();
  };
  const handleFieldChange = (e) => {
    const value = e.target.value;
    setFieldOfInterest(value);
    setShowScholarshipForm(!!value && locationType === 'Local');
    resetFeedback();
  };
  const handleCountryChange = (e) => {
    const value = e.target.value;
    setCountry(value);
    setShowScholarshipForm(!!value && locationType === 'Foreign');
    resetFeedback();
  };

  const validateForm = () => {
    const phoneRegex = /^[+]?[\d\s\-()]{10,}$/;
    if (!firstName.trim()) return 'Please enter your first name';
    if (!lastName.trim()) return 'Please enter your last name';
    if (!contactNumber.trim() || !phoneRegex.test(contactNumber)) return 'Please enter a valid contact number';
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Please enter a valid email address';
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    resetFeedback();
    const error = validateForm();
    if (error) { setErrorMsg(error); return; }
    if (!window.emailjs) { setErrorMsg('Unable to send right now. Please try again later.'); return; }
    setSubmitting(true);
    try {
      // Ensure hidden fields are set in the form
      if (formRef.current) {
        const formEl = formRef.current;
        const dateEl = formEl.querySelector('#date');
        if (dateEl) dateEl.value = new Date().toLocaleString();
      }
      await window.emailjs.sendForm('service_qkppwaq', 'template_inxdk3k', formRef.current);
      setSuccessMsg('Message sent successfully! One of our agents will get back to you.');
      // reset
      setShowScholarshipForm(false);
      setFirstName('');
      setLastName('');
      setContactNumber('');
      setEmail('');
      setMessage('');
    } catch (err) {
      setErrorMsg('Failed to send message. Please try again later.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      {/* Rocket Loading Animation */}
      {isLoading && (
        <div className="rocket-loading-overlay">
          <div className="rocket-container">
            <div className="rocket">
              <div className="rocket-body">
                <div className="rocket-nose"></div>
                <div className="rocket-window"></div>
                <div className="rocket-fins">
                  <div className="fin fin-left"></div>
                  <div className="fin fin-right"></div>
                </div>
              </div>
              <div className="rocket-flame">
                <div className="flame flame-1"></div>
                <div className="flame flame-2"></div>
                <div className="flame flame-3"></div>
                <div className="flame flame-4"></div>
                <div className="flame flame-5"></div>
                <div className="flame flame-6"></div>
                <div className="flame flame-7"></div>
              </div>
            </div>
            <div className="loading-text">
              <h3>Future Lanka</h3>
              <p>Launching your future</p>
            </div>
            <div className="stars">
              <div className="star star-1"></div>
              <div className="star star-2"></div>
              <div className="star star-3"></div>
              <div className="star star-4"></div>
              <div className="star star-5"></div>
            </div>
          </div>
        </div>
      )}

      <link
        href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Raleway:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
        rel="stylesheet"
      />
      
      {/* Hero Carousel Styles */}
      <style jsx>{`
        /* Hero Carousel Section */
        .hero-carousel-section {
          position: relative;
          height: 100vh;
          overflow: hidden;
        }
        /* Mobile Navbar Visibility Fix */
        #header .mobile-nav-toggle {
          display: none;
          cursor: pointer;
          font-size: 28px;
          line-height: 0;
          color: #fff;
        }
        #navbar.navbar-mobile {
          position: fixed;
          top: 60px;
          right: 0;
          left: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.9);
          transition: all 0.3s ease;
          z-index: 9999;
          overflow-y: auto;
          padding: 10px 15px;
        }
        #navbar.navbar-mobile ul {
          display: block !important;
          margin: 0;
          padding: 10px 0;
          width: 100%;
          position: relative;
          z-index: 10000;
        }
        #navbar.navbar-mobile > ul > li {
          display: block;
          margin: 0;
          padding: 8px 0;
        }
        #navbar.navbar-mobile > ul > li > a {
          display: block;
          padding: 10px 8px;
          color: #ffffff !important;
          visibility: visible !important;
          list-style: none;
          pointer-events: auto;
          text-decoration: none;
        }
        #navbar.navbar-mobile a {
          color: #fff !important;
          text-decoration: none;
        }

        /* Show hamburger and control menu visibility on mobile */
        @media (max-width: 991px) {
          #header .mobile-nav-toggle {
            display: block;
            position: relative;
            z-index: 10001;
            margin-left: 12px;
            color: #fff;
            text-shadow: 0 1px 2px rgba(0,0,0,0.4);
          }
          #navbar ul {
            display: none !important;
          }
          #navbar.navbar-mobile ul {
            display: block !important;
          }
          /* Ensure dropdown caret spacing clickable */
          #navbar .dropdown > a {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
          }
          /* Mobile-only submenu behavior */
          #navbar .dropdown > ul {
            display: none;
            margin: 8px 0 0 10px;
            padding-left: 10px;
            border-left: 2px solid rgba(255,255,255,0.1);
          }
          #navbar .dropdown > ul.dropdown-active {
            display: block;
          }
        }
        
        .hero-carousel {
          position: relative;
          width: 100%;
          height: 100%;
        }
        
        .carousel-slide {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: opacity 1s ease-in-out;
          display: flex;
          align-items: center;
        }
        
        .carousel-slide.active {
          opacity: 1;
        }
        
        .slide-image {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          z-index: 1;
        }
        
        .slide-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.62) 0%, rgba(0, 0, 0, 0.38) 100%);
          z-index: 2;
        }
        
        .slide-content {
          position: relative;
          z-index: 3;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          color: white;
        }
        
        .hero-title {
          font-size: 3.5rem;
          font-weight: 800;
          line-height: 1.2;
          margin-bottom: 30px;
          text-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
          animation: slideInUp 1s ease-out;
        }
        
        .highlight-text {
          color: #f7931e;
          position: relative;
        }
        
        .hero-subtitle {
          font-size: 1.3rem;
          font-weight: 400;
          line-height: 1.6;
          margin-bottom: 40px;
          max-width: 600px;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
          animation: slideInUp 1s ease-out 0.3s both;
        }
        
        .btn-get-started {
          display: inline-block;
          background: linear-gradient(45deg, #ff6b35, #f7931e);
          color: white;
          padding: 15px 30px;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 600;
          font-size: 1.1rem;
          transition: all 0.3s ease;
          box-shadow: 0 8px 25px rgba(255, 107, 53, 0.3);
          animation: slideInUp 1s ease-out 0.6s both;
        }
        
        .btn-get-started:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(255, 107, 53, 0.4);
          color: white;
          text-decoration: none;
        }
        
        /* Carousel Navigation */
        .carousel-nav {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          z-index: 4;
          pointer-events: none;
        }
        
        .nav-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255, 255, 255, 0.2);
          border: none;
          color: white;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          font-size: 1.5rem;
          cursor: pointer;
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
          pointer-events: all;
        }
        
        .nav-btn:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: translateY(-50%) scale(1.1);
        }
        
        .prev-btn {
          left: 30px;
        }
        
        .next-btn {
          right: 30px;
        }
        
        /* Indicators removed */
        
        /* Animations */
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(50px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        /* Responsive Design */
        @media (max-width: 1200px) {
          .hero-title {
            font-size: 3rem;
          }
          
          .hero-subtitle {
            font-size: 1.2rem;
          }
        }

        @media (max-width: 992px) {
          .hero-title {
            font-size: 2.8rem;
            margin-bottom: 25px;
          }
          
          .hero-subtitle {
            font-size: 1.15rem;
            margin-bottom: 35px;
          }
          
          .slide-content .container {
            padding-left: 20px;
            padding-right: 20px;
          }
        }

        @media (max-width: 768px) {
          .hero-carousel-section {
            height: 100vh;
            min-height: 600px;
          }
          
          .hero-title {
            font-size: 2.2rem;
            line-height: 1.3;
            margin-bottom: 20px;
          }
          
          .hero-subtitle {
            font-size: 1rem;
            line-height: 1.5;
            margin-bottom: 30px;
            max-width: 100%;
          }
          
          .btn-get-started {
            padding: 12px 25px;
            font-size: 1rem;
          }
          
          .nav-btn {
            width: 50px;
            height: 50px;
            font-size: 1.2rem;
          }
          
          .prev-btn {
            left: 15px;
          }
          
          .next-btn {
            right: 15px;
          }
          
          .slide-content .container {
            padding-left: 15px;
            padding-right: 15px;
          }
          
          .slide-content .row {
            margin: 0;
          }
          
          .slide-content .col-xl-8 {
            padding: 0;
            max-width: 100%;
            flex: 0 0 100%;
          }
        }
        
        @media (max-width: 576px) {
          .hero-title {
            font-size: 1.8rem;
            line-height: 1.4;
            margin-bottom: 15px;
          }
          
          .hero-subtitle {
            font-size: 0.95rem;
            line-height: 1.6;
            margin-bottom: 25px;
          }
          
          .btn-get-started {
            padding: 10px 20px;
            font-size: 0.9rem;
            display: block;
            text-align: center;
            width: fit-content;
            margin: 0 auto;
          }
          
          .nav-btn {
            width: 45px;
            height: 45px;
            font-size: 1rem;
          }
          
          .prev-btn {
            left: 10px;
          }
          
          .next-btn {
            right: 10px;
          }
          
          .slide-content .container {
            padding-left: 10px;
            padding-right: 10px;
          }
        }

        @media (max-width: 480px) {
          .hero-carousel-section {
            min-height: 500px;
          }
          
          .hero-title {
            font-size: 1.6rem;
            line-height: 1.4;
            margin-bottom: 12px;
          }
          
          .hero-subtitle {
            font-size: 0.9rem;
            line-height: 1.6;
            margin-bottom: 20px;
          }
          
          .btn-get-started {
            padding: 8px 18px;
            font-size: 0.85rem;
          }
          
          .nav-btn {
            width: 40px;
            height: 40px;
            font-size: 0.9rem;
          }
          
          .prev-btn {
            left: 8px;
          }
          
          .next-btn {
            right: 8px;
          }
        }

        @media (max-width: 360px) {
          .hero-title {
            font-size: 1.4rem;
            line-height: 1.3;
          }
          
          .hero-subtitle {
            font-size: 0.85rem;
            line-height: 1.5;
          }
          
          .btn-get-started {
            padding: 7px 15px;
            font-size: 0.8rem;
          }
        }

        /* Landscape orientation adjustments */
        @media (max-height: 500px) and (orientation: landscape) {
          .hero-carousel-section {
            height: 100vh;
            min-height: 100vh;
          }
          
          .hero-title {
            font-size: 1.8rem !important;
            margin-bottom: 10px;
          }
          
          .hero-subtitle {
            font-size: 0.9rem !important;
            margin-bottom: 15px;
          }
          
          .btn-get-started {
            padding: 8px 20px;
            font-size: 0.9rem;
          }
          
          .slide-content {
            align-items: flex-start;
            padding-top: 60px;
          }
        }

        /* Very small screens */
        @media (max-width: 320px) {
          .hero-title {
            font-size: 1.3rem;
            line-height: 1.2;
          }
          
          .hero-subtitle {
            font-size: 0.8rem;
            line-height: 1.4;
          }
          
          .btn-get-started {
            padding: 6px 12px;
            font-size: 0.75rem;
          }
          
          .nav-btn {
            width: 35px;
            height: 35px;
            font-size: 0.8rem;
          }
          
          .prev-btn {
            left: 5px;
          }
          
          .next-btn {
            right: 5px;
          }
        }

        /* Comprehensive Responsive Grid System */
        .services-grid {
          display: grid !important;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }

        .tools-grid {
          display: grid !important;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 20px;
        }

        .stats-grid {
          display: grid !important;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 30px;
          align-items: center;
          justify-content: center;
        }

        /* Large Desktop (1200px+) */
        @media (min-width: 1200px) {
          .services-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 30px;
          }
          .tools-grid {
            grid-template-columns: repeat(4, 1fr);
            gap: 25px;
          }
          .stats-grid {
            grid-template-columns: repeat(5, 1fr);
            gap: 40px;
          }
        }

        /* Desktop (992px - 1199px) */
        @media (max-width: 1199px) and (min-width: 992px) {
          .services-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
          }
          .tools-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
          }
          .stats-grid {
            grid-template-columns: repeat(5, 1fr);
            gap: 30px;
          }
        }

        /* Tablet (768px - 991px) */
        @media (max-width: 991px) and (min-width: 768px) {
          .services-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }
          .tools-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }
          .stats-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 25px;
          }
          
          .hero-title {
            font-size: 3rem;
          }
          
          .hero-subtitle {
            font-size: 1.2rem;
          }
        }

        /* Mobile Large (481px - 767px) */
        @media (max-width: 767px) and (min-width: 481px) {
          .services-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }
          .tools-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }
          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }
          
          .hero-title {
            font-size: 2.5rem;
          }
          
          .hero-subtitle {
            font-size: 1.1rem;
          }
        }

        /* Mobile Small (320px - 480px) */
        @media (max-width: 480px) {
          .services-grid {
            grid-template-columns: 1fr;
            gap: 15px;
          }
          .tools-grid {
            grid-template-columns: 1fr;
            gap: 15px;
          }
          .stats-grid {
            grid-template-columns: 1fr;
            gap: 15px;
          }
          
          .hero-title {
            font-size: 2rem;
          }
          
          .hero-subtitle {
            font-size: 1rem;
          }
        }

        /* Extra Small Mobile (< 320px) */
        @media (max-width: 319px) {
          .services-grid {
            grid-template-columns: 1fr;
            gap: 10px;
          }
          .tools-grid {
            grid-template-columns: 1fr;
            gap: 10px;
          }
          .stats-grid {
            grid-template-columns: 1fr;
            gap: 10px;
          }
          
          .hero-title {
            font-size: 1.8rem;
          }
          
          .hero-subtitle {
            font-size: 0.9rem;
          }
          
          .btn-get-started {
            padding: 10px 20px;
            font-size: 0.9rem;
          }
        }

        /* Rocket Loading Animation Styles */
        .rocket-loading-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #000000;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          overflow: hidden;
        }

        .rocket-loading-overlay::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: 
            radial-gradient(2px 2px at 20px 30px, #eee, transparent),
            radial-gradient(2px 2px at 40px 70px, rgba(255,255,255,0.8), transparent),
            radial-gradient(1px 1px at 90px 40px, #fff, transparent),
            radial-gradient(1px 1px at 130px 80px, rgba(255,255,255,0.6), transparent),
            radial-gradient(2px 2px at 160px 30px, #ddd, transparent),
            radial-gradient(1px 1px at 200px 60px, rgba(255,255,255,0.9), transparent),
            radial-gradient(1px 1px at 240px 20px, #fff, transparent),
            radial-gradient(2px 2px at 280px 70px, rgba(255,255,255,0.7), transparent),
            radial-gradient(1px 1px at 320px 40px, #eee, transparent),
            radial-gradient(1px 1px at 360px 80px, rgba(255,255,255,0.8), transparent),
            radial-gradient(2px 2px at 400px 30px, #fff, transparent),
            radial-gradient(1px 1px at 440px 60px, rgba(255,255,255,0.6), transparent),
            radial-gradient(1px 1px at 480px 20px, #ddd, transparent),
            radial-gradient(2px 2px at 520px 70px, rgba(255,255,255,0.9), transparent),
            radial-gradient(1px 1px at 560px 40px, #fff, transparent),
            radial-gradient(1px 1px at 600px 80px, rgba(255,255,255,0.7), transparent),
            radial-gradient(2px 2px at 640px 30px, #eee, transparent),
            radial-gradient(1px 1px at 680px 60px, rgba(255,255,255,0.8), transparent),
            radial-gradient(1px 1px at 720px 20px, #fff, transparent),
            radial-gradient(2px 2px at 760px 70px, rgba(255,255,255,0.6), transparent);
          background-repeat: repeat;
          background-size: 800px 100px;
          animation: starField 20s linear infinite;
        }

        .rocket-loading-overlay::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: 
            radial-gradient(1px 1px at 50px 50px, rgba(255,255,255,0.4), transparent),
            radial-gradient(1px 1px at 150px 25px, rgba(255,255,255,0.3), transparent),
            radial-gradient(1px 1px at 250px 75px, rgba(255,255,255,0.5), transparent),
            radial-gradient(1px 1px at 350px 45px, rgba(255,255,255,0.2), transparent),
            radial-gradient(1px 1px at 450px 15px, rgba(255,255,255,0.4), transparent),
            radial-gradient(1px 1px at 550px 65px, rgba(255,255,255,0.3), transparent),
            radial-gradient(1px 1px at 650px 35px, rgba(255,255,255,0.5), transparent),
            radial-gradient(1px 1px at 750px 85px, rgba(255,255,255,0.2), transparent);
          background-repeat: repeat;
          background-size: 800px 100px;
          animation: starField 25s linear infinite reverse;
        }

        .rocket-container {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 2;
          padding-top: 50px;
        }

        .rocket {
          position: relative;
          animation: rocketFly 2s ease-in-out infinite, rocketRotate 4s linear infinite, rocketPulse 1.5s ease-in-out infinite;
          transform-origin: center;
        }

        .rocket-body {
          position: relative;
          width: 60px;
          height: 120px;
          background: transparent;
          border: 3px solid #ffffff;
          border-radius: 30px 30px 15px 15px;
          box-shadow: 0 0 20px rgba(255, 255, 255, 0.8), inset 0 0 20px rgba(255, 255, 255, 0.1);
        }

        .rocket-nose {
          position: absolute;
          top: -20px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 15px solid transparent;
          border-right: 15px solid transparent;
          border-bottom: 25px solid transparent;
          border-bottom-color: #ffffff;
          filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.8));
        }

        .rocket-window {
          position: absolute;
          top: 20px;
          left: 50%;
          transform: translateX(-50%);
          width: 20px;
          height: 20px;
          background: transparent;
          border-radius: 50%;
          border: 2px solid #ffffff;
          box-shadow: 0 0 15px rgba(255, 255, 255, 0.6), inset 0 0 10px rgba(255, 255, 255, 0.2);
        }

        .rocket-fins {
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 20px;
        }

        .fin {
          position: absolute;
          width: 0;
          height: 0;
          border-style: solid;
        }

        .fin-left {
          left: 0;
          border-left: 20px solid transparent;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
          border-left-color: #ffffff;
          filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.7));
        }

        .fin-right {
          right: 0;
          border-right: 20px solid transparent;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
          border-right-color: #ffffff;
          filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.7));
        }

        .rocket-flame {
          position: absolute;
          bottom: -40px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 60px;
        }

        .flame {
          position: absolute;
          border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
          animation: flameFlicker 0.3s ease-in-out infinite alternate;
        }

        .flame-1 {
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 18px;
          height: 35px;
          background: linear-gradient(45deg, #ff0000, #ff4500, #ffff00);
          animation-delay: 0s;
        }

        .flame-2 {
          bottom: 5px;
          left: 30%;
          transform: translateX(-50%) rotate(-20deg);
          width: 12px;
          height: 25px;
          background: linear-gradient(45deg, #ff4500, #ff8800, #ffff00);
          animation-delay: 0.1s;
        }

        .flame-3 {
          bottom: 5px;
          right: 30%;
          transform: translateX(50%) rotate(20deg);
          width: 12px;
          height: 25px;
          background: linear-gradient(45deg, #ff4500, #ff8800, #ffff00);
          animation-delay: 0.2s;
        }

        .flame-4 {
          bottom: 8px;
          left: 20%;
          transform: translateX(-50%) rotate(-35deg);
          width: 8px;
          height: 20px;
          background: linear-gradient(45deg, #ff8800, #ffff00, #ffffff);
          animation-delay: 0.3s;
        }

        .flame-5 {
          bottom: 8px;
          right: 20%;
          transform: translateX(50%) rotate(35deg);
          width: 8px;
          height: 20px;
          background: linear-gradient(45deg, #ff8800, #ffff00, #ffffff);
          animation-delay: 0.4s;
        }

        .flame-6 {
          bottom: 10px;
          left: 10%;
          transform: translateX(-50%) rotate(-50deg);
          width: 6px;
          height: 15px;
          background: linear-gradient(45deg, #ffff00, #ffffff);
          animation-delay: 0.5s;
        }

        .flame-7 {
          bottom: 10px;
          right: 10%;
          transform: translateX(50%) rotate(50deg);
          width: 6px;
          height: 15px;
          background: linear-gradient(45deg, #ffff00, #ffffff);
          animation-delay: 0.6s;
        }

        .loading-text {
          text-align: center;
          margin-top: 40px;
          color: #fff;
          animation: textGlow 2s ease-in-out infinite alternate;
          z-index: 3;
          position: relative;
          text-shadow: 0 0 30px rgba(255, 255, 255, 0.8);
        }

        .loading-text h3 {
          font-size: 3rem;
          font-weight: 800;
          margin-bottom: 15px;
          color: #f7931e;
          text-shadow: 0 0 20px rgba(247, 147, 30, 1), 0 0 40px rgba(247, 147, 30, 0.8);
          letter-spacing: 2px;
        }

        .loading-text p {
          font-size: 1.4rem;
          opacity: 1;
          color: #ffffff;
          text-shadow: 0 0 15px rgba(255, 255, 255, 0.9);
          animation: textPulse 1.5s ease-in-out infinite;
          font-weight: 500;
        }

        .stars {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 1;
        }

        .star {
          position: absolute;
          background: #fff;
          border-radius: 50%;
          animation: starTwinkle 3s ease-in-out infinite;
          box-shadow: 0 0 6px rgba(255, 255, 255, 0.8);
        }

        .star-1 {
          top: 15%;
          left: 8%;
          width: 4px;
          height: 4px;
          animation-delay: 0s;
          background: radial-gradient(circle, #fff 0%, rgba(255,255,255,0.3) 100%);
        }

        .star-2 {
          top: 25%;
          right: 12%;
          width: 3px;
          height: 3px;
          animation-delay: 0.8s;
          background: radial-gradient(circle, #fff 0%, rgba(255,255,255,0.4) 100%);
        }

        .star-3 {
          top: 55%;
          left: 15%;
          width: 5px;
          height: 5px;
          animation-delay: 1.6s;
          background: radial-gradient(circle, #fff 0%, rgba(255,255,255,0.5) 100%);
        }

        .star-4 {
          top: 65%;
          right: 20%;
          width: 3px;
          height: 3px;
          animation-delay: 2.4s;
          background: radial-gradient(circle, #fff 0%, rgba(255,255,255,0.3) 100%);
        }

        .star-5 {
          top: 35%;
          left: 45%;
          width: 4px;
          height: 4px;
          animation-delay: 3.2s;
          background: radial-gradient(circle, #fff 0%, rgba(255,255,255,0.4) 100%);
        }

        @keyframes rocketFly {
          0% {
            transform: translateY(20px) rotate(45deg) scale(1);
          }
          25% {
            transform: translateY(-10px) rotate(53deg) scale(1);
          }
          50% {
            transform: translateY(-40px) rotate(45deg) scale(1);
          }
          75% {
            transform: translateY(-10px) rotate(37deg) scale(1);
          }
          100% {
            transform: translateY(20px) rotate(45deg) scale(1);
          }
        }

        @keyframes rocketRotate {
          0% {
            transform: translateY(20px) rotate(45deg) scale(1);
          }
          25% {
            transform: translateY(20px) rotate(50deg) scale(1);
          }
          50% {
            transform: translateY(20px) rotate(45deg) scale(1);
          }
          75% {
            transform: translateY(20px) rotate(40deg) scale(1);
          }
          100% {
            transform: translateY(20px) rotate(45deg) scale(1);
          }
        }

        @keyframes rocketPulse {
          0%, 100% {
            transform: translateY(20px) rotate(45deg) scale(1);
            filter: brightness(1);
          }
          50% {
            transform: translateY(20px) rotate(45deg) scale(1.05);
            filter: brightness(1.2);
          }
        }

        @keyframes flameFlicker {
          0% {
            opacity: 0.7;
            transform: scaleY(1) scaleX(1);
          }
          25% {
            opacity: 1;
            transform: scaleY(1.3) scaleX(0.9);
          }
          50% {
            opacity: 0.9;
            transform: scaleY(1.1) scaleX(1.1);
          }
          75% {
            opacity: 1;
            transform: scaleY(1.4) scaleX(0.8);
          }
          100% {
            opacity: 0.8;
            transform: scaleY(1) scaleX(1);
          }
        }

        @keyframes textGlow {
          0% {
            text-shadow: 0 0 20px rgba(247, 147, 30, 0.8), 0 0 40px rgba(247, 147, 30, 0.6);
          }
          100% {
            text-shadow: 0 0 30px rgba(247, 147, 30, 1), 0 0 50px rgba(247, 147, 30, 0.8), 0 0 70px rgba(247, 147, 30, 0.4);
          }
        }

        @keyframes textPulse {
          0%, 100% {
            opacity: 0.9;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.02);
          }
        }

        @keyframes starField {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-800px);
          }
        }

        @keyframes starTwinkle {
          0%, 100% {
            opacity: 0.4;
            transform: scale(1);
            box-shadow: 0 0 6px rgba(255, 255, 255, 0.8);
          }
          50% {
            opacity: 1;
            transform: scale(1.3);
            box-shadow: 0 0 12px rgba(255, 255, 255, 1);
          }
        }

        /* Rocket responsive adjustments */
        @media (max-width: 768px) {
          .rocket-container {
            padding-top: 30px;
          }
          
          .loading-text {
            margin-top: 30px;
          }
          
          .loading-text h3 {
            font-size: 2.2rem;
            letter-spacing: 1px;
            margin-bottom: 12px;
          }
          
          .loading-text p {
            font-size: 1.1rem;
            font-weight: 400;
          }
          
          .rocket-body {
            width: 50px;
            height: 100px;
            border-width: 2px;
          }
          
          .rocket-nose {
            border-left: 12px solid transparent;
            border-right: 12px solid transparent;
            border-bottom: 20px solid transparent;
            border-bottom-color: #ffffff;
          }
          
          .rocket-window {
            width: 16px;
            height: 16px;
            border-width: 1px;
          }
          
          .fin-left, .fin-right {
            border-left-width: 16px;
            border-right-width: 16px;
            border-top-width: 8px;
            border-bottom-width: 8px;
          }
          
          .rocket-flame {
            width: 60px;
            height: 45px;
          }
          
          .flame-1 {
            width: 14px;
            height: 26px;
          }
          
          .flame-2, .flame-3 {
            width: 10px;
            height: 20px;
          }
          
          .flame-4, .flame-5 {
            width: 6px;
            height: 15px;
          }
          
          .flame-6, .flame-7 {
            width: 5px;
            height: 12px;
          }
        }

        @media (max-width: 480px) {
          .rocket-container {
            padding-top: 20px;
          }
          
          .loading-text {
            margin-top: 25px;
          }
          
          .loading-text h3 {
            font-size: 1.8rem;
            letter-spacing: 0.5px;
            margin-bottom: 10px;
          }
          
          .loading-text p {
            font-size: 1rem;
          }
          
          .rocket-body {
            width: 40px;
            height: 80px;
            border-width: 1.5px;
          }
          
          .rocket-nose {
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 16px solid transparent;
            border-bottom-color: #ffffff;
          }
          
          .rocket-window {
            width: 12px;
            height: 12px;
            border-width: 1px;
          }
          
          .fin-left, .fin-right {
            border-left-width: 12px;
            border-right-width: 12px;
            border-top-width: 6px;
            border-bottom-width: 6px;
          }
          
          .rocket-flame {
            width: 50px;
            height: 35px;
          }
          
          .flame-1 {
            width: 12px;
            height: 22px;
          }
          
          .flame-2, .flame-3 {
            width: 8px;
            height: 16px;
          }
          
          .flame-4, .flame-5 {
            width: 5px;
            height: 12px;
          }
          
          .flame-6, .flame-7 {
            width: 4px;
            height: 10px;
          }
        }
      `}</style>

      {/* ======= Header ======= */}
      <header id="header" className="fixed-top d-flex align-items-center">
        <div className="container d-flex align-items-center">
          <h1 className="logo me-auto">
            <a href="index.html">
              <img src={logoImg} style={{ width: '70px', maxHeight: '95px' }} alt="FLRDF Logo" />
            </a>
          </h1>
          <nav id="navbar" className={`navbar order-last order-lg-0 ${mobileNavOpen ? 'navbar-mobile' : ''}`}>
            <ul style={{ display: mobileNavOpen ? 'block' : undefined }}>
              <li><a className="nav-link scrollto active" href="index.html#hero">Home</a></li>
              <li><a className="nav-link scrollto" href="index.html#services">Services</a></li>
              <li className="dropdown">
                <a href="index.html" onClick={(e) => { if (mobileNavOpen) { e.preventDefault(); const next = e.currentTarget.nextElementSibling; if (next) next.classList.toggle('dropdown-active'); } }}><span>Projects</span> <i className="bi bi-chevron-down"></i></a>
                <ul>
                  {/* <li><a href="pro5.html#scl" target="_blank" rel="noopener noreferrer">National Career Guidance<br />Awareness School Program</a></li> */}
                  {/* 1 */}
                  {/* <li><a href="pro5.html#scl" target="_blank" rel="noopener noreferrer">School Awareness Program</a></li> */}
                    <li><a href="schAwareness.html" target="_blank" rel="noopener noreferrer">School Awareness Program</a></li>
                  {/* 2 */}
                  <li><a href="podcasts.html" target="_blank" rel="noopener noreferrer">National Career Guidance Podcast</a></li>
                  {/* 3 */}
                  <li><a href="InAwareness.html" target="_blank" rel="noopener noreferrer">Industry Awareness / Reinforcement Program</a></li>
                  {/* 4 */}
                  <li><a href="schol.html" target="_blank" rel="noopener noreferrer">Annual Scholarship Program</a></li>
                  {/* 5 */}
                  <li className="dropdown">
                    <a href="#">
                      <span>Annual STEM Development Program</span> <i className="bi bi-chevron-right"></i>
                    </a>
                    <ul>
                      {/* 2024 Group */}
                      <li >
                        <a href="oppen.html">
                          2024 - Oppenheim 
                        </a>
                        {/* <ul>
                          <li>
                            <a href="oppen.html#e1" target="_blank" rel="noopener noreferrer">
                              Colombo - Edition 1
                            </a>
                          </li>
                          <li>
                            <a href="oppen.html#e2" target="_blank" rel="noopener noreferrer">
                              Gampaha - Edition 2
                            </a>
                          </li>
                          <li>
                            <a href="oppen.html#e3" target="_blank" rel="noopener noreferrer">
                              Colombo - Edition 3
                            </a>
                          </li>
                        </ul> */}
                      </li>

                      {/* 2025 Group */}
                      <li className="dropdown">
                        <a href="stemPro2025.html">
                          2025 - 100th Year Quantum 
                        </a>
                        {/* <ul>
                          <li>
                            <a href="" target="_blank" rel="noopener noreferrer">
                              Topic 1
                            </a>
                          </li>
                          <li>
                            <a href="" target="_blank" rel="noopener noreferrer">
                              Topic 2
                            </a>
                          </li>
                          <li>
                            <a href="" target="_blank" rel="noopener noreferrer">
                              Topic 3
                            </a>
                          </li>
                        </ul> */}
                      </li>
                    </ul>
                  </li>


                  {/* <li><a href="pro5.html#pod" target="_blank" rel="noopener noreferrer">National Career Guidance Podcast</a></li> */}
                  {/* <li><a href="pro3.html" target="_blank" rel="noopener noreferrer">Innovate Ceylon</a></li> */}

                  {/* 6 */}
                  <li><a href="TTraining.html" target="_blank" rel="noopener noreferrer">Teacher Trainning Programs</a></li>
                  {/* 7 */}
                  <li><a href="researchDev.html" target="_blank" rel="noopener noreferrer">Research and Development</a></li>
                  {/* 8 */}
                  <li><a href="sustainability.html" target="_blank" rel="noopener noreferrer">Sustainability Development</a></li>
                  {/* 9 */}
                  <li><a href="CSR.html" target="_blank" rel="noopener noreferrer">CSR</a></li>
                  {/* <li><a className="nav-link disabled" tabIndex="-1" aria-disabled="true" href="#" target="_blank" rel="noopener noreferrer">Business Scientist Bootcamp</a></li> */}
                  {/* <li><a className="nav-link disabled" tabIndex="-1" aria-disabled="true" href="#" target="_blank" rel="noopener noreferrer">Annual Scholarship Program</a></li> */}
                  {/* <li><a className="nav-link disabled" tabIndex="-1" aria-disabled="true" href="#" target="_blank" rel="noopener noreferrer">Soft Skill Development Program</a></li> */}
                  <li><a href="filmComp.html" target="_blank" rel="noopener noreferrer">Inter School Short Film Competition</a></li>
                </ul>
              </li>
              <li className="dropdown">
                <a href="index.html" onClick={(e) => { if (mobileNavOpen) { e.preventDefault(); const next = e.currentTarget.nextElementSibling; if (next) next.classList.toggle('dropdown-active'); } }}><span>Events</span> <i className="bi bi-chevron-down"></i></a>
                <ul>
                  <li><a href="schAwareness.html" target="_blank" rel="noopener noreferrer">School Awareness Programs</a></li>

                  <li className="dropdown">
                    <a href="#"><span>Annual STEM Development Program</span> <i className="bi bi-chevron-right"></i></a>
                    <ul>
                      <li><a href="oppen.html" target="_blank" rel="noopener noreferrer">2024 - Oppenheim</a></li>
                      <li><a href="stemPro2025.html" target="_blank" rel="noopener noreferrer">2025 - 100th Year Quantum</a></li>
                    </ul>
                  </li>
                  <li><a href="TTraining.html" target="_blank" rel="noopener noreferrer">Teacher Trainning Programs</a></li>
                  <li><a href="sustainability.html" target="_blank" rel="noopener noreferrer">Sustainability Development</a></li>

                </ul>
              </li>
              {/* <li><a className="nav-link scrollto" href="gallery.html">Gallery</a></li> */}
              <li><a className="nav-link scrollto" href="about.html">About Us</a></li>
              <li><a className="nav-link scrollto" href="index.html#faq">FAQs</a></li>
              <li><a className="nav-link scrollto" href="index.html#contact-form">Contact Us</a></li>
            </ul>
            <i
              className={`bi ${mobileNavOpen ? 'bi-x' : 'bi-list'} mobile-nav-toggle`}
              onClick={toggleMobileNav}
              role="button"
              aria-label="Toggle navigation"
              aria-expanded={mobileNavOpen ? 'true' : 'false'}
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleMobileNav(); }}
            ></i>
          </nav>

          {mobileNavOpen && (
            <div
              style={{
                position: 'fixed',
                top: 60,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0,0,0,0.95)',
                zIndex: 10000,
                overflowY: 'auto',
              }}
              role="dialog"
              aria-modal="true"
              aria-label="Mobile navigation"
              onKeyDown={(e) => { if (e.key === 'Escape') setMobileNavOpen(false); }}
            >
              <button
                type="button"
                onClick={() => setMobileNavOpen(false)}
                aria-label="Close menu"
                style={{
                  position: 'sticky',
                  top: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  width: '100%',
                  background: 'transparent',
                  border: 'none',
                  color: '#fff',
                  padding: '12px 16px',
                  zIndex: 10001,
                  cursor: 'pointer',
                }}
              >
                <i className="bi bi-x" style={{ fontSize: '28px' }}></i>
              </button>
              <ul style={{ listStyle: 'none', margin: 0, padding: '16px' }}>
                <li style={{ marginBottom: '8px' }}>
                  <a href="index.html#hero" className="nav-link scrollto" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '10px 8px' }}>Home</a>
                </li>
                <li style={{ marginBottom: '8px' }}>
                  <a href="index.html#services" className="nav-link scrollto" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '10px 8px' }}>Services</a>
                </li>
                <li style={{ marginBottom: '8px' }}>
                  <div
                    onClick={() => setMobileProjectsOpen(!mobileProjectsOpen)}
                    style={{ color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', padding: '10px 8px' }}
                  >
                    <span>Projects</span>
                    <i className={`bi ${mobileProjectsOpen ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                  </div>
                  {mobileProjectsOpen && (
                    <ul style={{ listStyle: 'none', margin: 0, padding: '0 0 0 12px' }}>
                      <li><a href="schAwareness.html" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>School Awareness Program</a></li>
                      <li><a href="podcasts.html" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>National Career Guidance Podcast</a></li>
                      <li><a href="InAwareness.html" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>Industry Awareness / Reinforcement Program</a></li>
                      <li><a href="schol.html" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>Annual Scholarship Program</a></li>
                      <li><a href="oppen.html" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>2024 - Oppenheim</a></li>
                      <li><a href="stemPro2025.html" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>2025 - 100th Year Quantum</a></li>
                      <li><a href="TTraining.html" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>Teacher Trainning Programs</a></li>
                      <li><a href="researchDev.html" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>Research and Development</a></li>
                      <li><a href="sustainability" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>Sustainability Development</a></li>
                      <li><a href="CSR.html" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>CSR</a></li>
                      <li><a href="filmComp.html" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>Inter School Short Film Competition</a></li>
                    </ul>
                  )}
                </li>
                <li style={{ marginBottom: '8px' }}>
                  <div
                    onClick={() => setMobileEventsOpen(!mobileEventsOpen)}
                    style={{ color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', padding: '10px 8px' }}
                  >
                    <span>Events</span>
                    <i className={`bi ${mobileEventsOpen ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                  </div>
                  {mobileEventsOpen && (
                    <ul style={{ listStyle: 'none', margin: 0, padding: '0 0 0 12px' }}>
                      <li><a href="Event1.html" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>School Awareness Programs</a></li>
                      <li><a href="." target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>Annual STEM Development Program</a></li>
                      <li><a href="TTraining.html" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>Teacher Trainning Programs</a></li>
                      <li><a href="sustainability.html" target="_blank" rel="noopener noreferrer" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '8px 8px' }}>Sustainability Development</a></li>
                    </ul>
                  )}
                </li>
                <li style={{ marginBottom: '8px' }}>
                  <a href="about.html" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '10px 8px' }}>About Us</a>
                </li>
                <li style={{ marginBottom: '8px' }}>
                  <a href="index.html#faq" className="nav-link scrollto" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '10px 8px' }}>FAQs</a>
                </li>
                <li style={{ marginBottom: '8px' }}>
                  <a href="index.html#contact-form" className="nav-link scrollto" onClick={() => setMobileNavOpen(false)} style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '10px 8px' }}>Contact Us</a>
                </li>
              </ul>
            </div>
          )}
        </div>
      </header>

      {/* ======= Hero Section with Carousel ======= */}
      <section id="hero" className="hero-carousel-section">
        <div className="hero-carousel">
          <div className="carousel-slide active">
            <div className="slide-image" style={{ backgroundImage: "url('/assets/img/hero/1.JPG')" }}></div>
            <div className="slide-overlay"></div>
            <div className="slide-content">
              <div className="container">
                <div className="row">
                  <div className="col-xl-8">
                    <h1 className="hero-title">
                      Welcome to Sri Lanka's Premier
                      <br />
                      <span className="highlight-text">Career Guidance</span>
                      <br />
                      and
                      <br />
                      <span className="highlight-text">Skill Development</span>
                      <br />
                      Network!
                    </h1>
                    <h2 className="hero-subtitle">
                      Discover your true potential with Future Lanka, where self-discovery aligns with the
                      cutting-edge of education and innovation. Dive into endless possibilities!
                    </h2>
                    <a href="#contact-form" className="btn-get-started scrollto">Contact Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="carousel-slide">
            <div className="slide-image" style={{ backgroundImage: "url('/assets/img/hero/2.JPG')" }}></div>
            <div className="slide-overlay"></div>
            <div className="slide-content">
              <div className="container">
                <div className="row">
                  <div className="col-xl-8">
                    <h1 className="hero-title">
                      Empowering Students Through
                      <br />
                      <span className="highlight-text">STEAM Education</span>
                      <br />
                      and
                      <br />
                      <span className="highlight-text">Career Guidance</span>
                    </h1>
                    <h2 className="hero-subtitle">
                      Join over 60,000+ students who have discovered their true potential with our comprehensive
                      educational programs and personalized career guidance services.
                    </h2>
                    <a href="#services" className="btn-get-started scrollto">Explore Services</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="carousel-slide">
            <div className="slide-image" style={{ backgroundImage: "url('/assets/img/hero/3.jpg')" }}></div>
            <div className="slide-overlay"></div>
            <div className="slide-content">
              <div className="container">
                <div className="row">
                  <div className="col-xl-8">
                    <h1 className="hero-title">
                      Building Tomorrow's
                      <br />
                      <span className="highlight-text">Leaders</span>
                      <br />
                      Today
                    </h1>
                    <h2 className="hero-subtitle">
                      Partner with 300+ schools and 950+ industry experts to shape the future of education
                      and career development across Sri Lanka.
                    </h2>
                    <a href="#services" className="btn-get-started scrollto">Get Started</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="carousel-slide">
            <div className="slide-image" style={{ backgroundImage: "url('/assets/img/hero/4.jpg')" }}></div>
            <div className="slide-overlay"></div>
            <div className="slide-content">
              <div className="container">
                <div className="row">
                  <div className="col-xl-8">
                    <h1 className="hero-title">
                      Guiding You To
                      <br />
                      <span className="highlight-text">Success</span>
                    </h1>
                    <h2 className="hero-subtitle">
                      Personalized guidance, powerful tools, and a network built for your growth.
                    </h2>
                    <a href="#contact-form" className="btn-get-started scrollto">Contact Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Carousel Navigation */}
        <div className="carousel-nav">
          <button className="nav-btn prev-btn" onClick={() => changeSlide(-1)}>
            <i className="bi bi-chevron-left"></i>
          </button>
          <button className="nav-btn next-btn" onClick={() => changeSlide(1)}>
            <i className="bi bi-chevron-right"></i>
          </button>
        </div>
        
        {/* Indicators removed for auto-only carousel */}
      </section>


      {/* ======= Tabs Section ======= */}


      <section id="services" className="services" style={{ padding: "50px 0" }}>
        <div className="container" data-aos="fade-up">
          <div className="section-title" style={{ textAlign: "center", marginBottom: "40px" }}>
            <h2 style={{ fontWeight: "700", fontSize: "28px", color: "#222" }}>What We Do?</h2>
            <p style={{ color: "#555", fontSize: "15px", maxWidth: "700px", margin: "10px auto" }}>
              At the Future Lanka Research and Development Foundation, we empower learners and professionals to unlock their full potential through tailored educational consulting and career guidance.
              <br /><br />
              Leveraging the power of STEAM education (Science, Technology, Engineering, Arts & Mathematics), we inspire creativity, innovation, and success.
            </p>
          </div>

          {/* Grid for cards */}
          <div
            className="row services-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)", // 3 columns
              gap: "20px",
            }}
          >
            {/* Card 1 */}
            <div
              className="card"
              style={{
                position: "relative",
                textAlign: "center",
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "40px 20px 20px 20px",
                transition: "0.3s",
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-25px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  padding: "5px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                <lord-icon
                  src="https://cdn.lordicon.com/smjqtlxm.json"
                  trigger="loop"
                  colors="primary:#242424,secondary:#e88c30"
                  style={{ width: "50px", height: "50px" }}
                />
              </div>
              <h6 style={{ fontWeight: "600", fontSize: "16px", marginBottom: "10px", marginTop: "30px" }}>
                Skill / Passion Identification
              </h6>
              <p style={{ fontSize: "14px", color: "#555" }}>
                Embark on a journey of self-discovery with our customized assessments. Find your unique strengths and ignite your passions to carve a fulfilling career path.
              </p>
            </div>

            {/* Card 2 */}
            <div
              className="card"
              style={{
                position: "relative",
                textAlign: "center",
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "40px 20px 20px 20px",
                transition: "0.3s",
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-25px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  padding: "5px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                <lord-icon
                  src="https://cdn.lordicon.com/jvucoldz.json"
                  trigger="loop"
                  colors="primary:#242424,secondary:#f7931d"
                  style={{ width: "50px", height: "50px" }}
                />
              </div>
              <h6 style={{ fontWeight: "600", fontSize: "16px", marginBottom: "10px", marginTop: "30px" }}>
                Industry and Career Exploration
              </h6>
              <p style={{ fontSize: "14px", color: "#555" }}>
                Dive into the vast world of opportunities with our expert guidance. Discover the perfect intersection of passion and profession, and navigate your future with confidence.
              </p>
            </div>

            {/* Card 3 */}
            <div
              className="card"
              style={{
                position: "relative",
                textAlign: "center",
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "40px 20px 20px 20px",
                transition: "0.3s",
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-25px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  padding: "5px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                <lord-icon
                  src="https://cdn.lordicon.com/zhiiqoue.json"
                  trigger="loop"
                  colors="primary:#242424,secondary:#f7931d"
                  style={{ width: "45px", height: "45px" }}
                />
              </div>
              <h6 style={{ fontWeight: "600", fontSize: "16px", marginBottom: "10px", marginTop: "30px" }}>
                Higher Education Networking
              </h6>
              <p style={{ fontSize: "14px", color: "#555" }}>
                Elevate your academic pursuits with our extensive network of top-tier educational institutions. Let us connect you to your ideal academic journey that aligns seamlessly with your career aspirations.
              </p>
            </div>

            {/* Card 4 */}
            <div
              className="card"
              style={{
                position: "relative",
                textAlign: "center",
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "40px 20px 20px 20px",
                transition: "0.3s",
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-25px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  padding: "5px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                <lord-icon
                  src="https://cdn.lordicon.com/nocovwne.json"
                  trigger="loop"
                  colors="primary:#242424,secondary:#f7931d"
                  style={{ width: "50px", height: "50px" }}
                />
              </div>
              <h6 style={{ fontWeight: "600", fontSize: "16px", marginBottom: "10px", marginTop: "30px" }}>
                Skill Development
              </h6>
              <p style={{ fontSize: "14px", color: "#555" }}>
                Enhance your skills with training programs designed to make you industry-ready and future-proof.
              </p>
            </div>

            {/* Card 5 */}
            <div
              className="card"
              style={{
                position: "relative",
                textAlign: "center",
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "40px 20px 20px 20px",
                transition: "0.3s",
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-25px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  padding: "5px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                <lord-icon
                  src="https://cdn.lordicon.com/ivhjpjsw.json"
                  trigger="loop"
                  colors="primary:#242424,secondary:#f7931d"
                  style={{ width: "50px", height: "50px" }}
                />
              </div>
              <h6 style={{ fontWeight: "600", fontSize: "16px", marginBottom: "10px", marginTop: "30px" }}>
                STEM Integration
              </h6>
              <p style={{ fontSize: "14px", color: "#555" }}>
                Learn through Science, Technology, Engineering, Arts, and Mathematics. We help you build problem-solving and creative thinking skills for future success.
              </p>
            </div>

            {/* Card 6 */}
            <div
              className="card"
              style={{
                position: "relative",
                textAlign: "center",
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "40px 20px 20px 20px",
                transition: "0.3s",
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-25px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  padding: "5px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                <lord-icon
                  src="https://cdn.lordicon.com/jdgfsfzr.json"
                  trigger="loop"
                  colors="primary:#242424,secondary:#f7931d"
                  style={{ width: "50px", height: "50px" }}
                />
              </div>
              <h6 style={{ fontWeight: "600", fontSize: "16px", marginBottom: "10px", marginTop: "30px" }}>
                Employment Support
              </h6>
              <p style={{ fontSize: "14px", color: "#555" }}>
                Get ready for the world of work with our support. From CVs and interviews to finding the right job, we guide you every step of the way.
              </p>
            </div>
          </div>
        </div>
      </section>




      <section
        style={{
          backgroundColor: "#d46e15ff",
          color: "#fff",
          padding: "60px 0",
          textAlign: "center",
        }}
      >
        <div className="stats-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
            gap: "30px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >

<div>
            <BiBuildingHouse size={32} style={{ marginBottom: "10px" }} />
            <div style={{ fontSize: "26px", fontWeight: "700" }}>300+</div>
            <p style={{ fontSize: "14px", marginTop: "5px" }}>Schools Impacted Annually</p>
          </div>
            
          <div>
            <BiBookReader size={32} style={{ marginBottom: "10px" }} />
            <div style={{ fontSize: "26px", fontWeight: "700" }}>60,000+</div>
            <p style={{ fontSize: "14px", marginTop: "5px" }}>Students Guided Every Year</p>
          </div>

          <div>
            <BiUserCircle size={32} style={{ marginBottom: "10px" }} />
            <div style={{ fontSize: "26px", fontWeight: "700" }}>950+</div>
            <p style={{ fontSize: "14px", marginTop: "5px" }}>Industry Experts in Our Network</p>
          </div>



          <div>
            <BiBriefcaseAlt size={32} style={{ marginBottom: "10px" }} />
            <div style={{ fontSize: "26px", fontWeight: "700" }}>250+</div>
            <p style={{ fontSize: "14px", marginTop: "5px" }}>Higher Education Partners</p>
          </div>

          <div>
            <BiAward size={32} style={{ marginBottom: "10px" }} />
            <div style={{ fontSize: "26px", fontWeight: "700" }}>500+</div>
            <p style={{ fontSize: "14px", marginTop: "5px" }}>Scholarships Awarded Annually</p>
          </div>
        </div>
      </section>



      <section className="services" style={{
        padding: "50px 0",
        // backgroundColor: "#fafafa" 
      }}>
        <div
          className="container"
          data-aos="fade-up"
          style={{
            // border: "2px solid #f1ede9",
            padding: "40px",
            // borderRadius: "15px",
            transition: "0.3s all",
            backgroundColor: "#fff",
            // boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
          }}
        >
          <div className="section-title" style={{ textAlign: "center", marginBottom: "10px" }}>
            <h2 style={{ fontWeight: "700", fontSize: "28px", color: "#222" }}>
              Unlock Your Potential
            </h2>
            <p style={{ color: "#555", fontSize: "15px", maxWidth: "700px", margin: "10px auto" }}>
              Future Lanka offers a suite of innovative tools to help students navigate their
              educational and career paths
            </p>
          </div>

          {/* Grid for cards */}
          <div
            className="row tools-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "20px",
            }}
          >
            {/* Card 1 */}
            <div
              className="card"
              style={{
                textAlign: "center",
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "20px",
                transition: "0.3s",
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <div>
                <h6 style={{ fontWeight: "600", fontSize: "16px", marginBottom: "10px" }}>
                  <i className="bi bi-journal-bookmark" style={{ marginRight: "8px", color: "#f7931d" }}></i>
                  UGC Course Guide Bot
                </h6>
                <p style={{ fontSize: "14px", color: "#555", marginBottom: "15px" }}>
                  A bot to help you list degrees and courses based on your subject combination.
                </p>
              </div>
              <div style={{ textAlign: "center" }}>
                <a href="bot.html">
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#efefef",
                      fontSize: "14px",
                      border: "none",
                      borderRadius: "20px",
                      color: "#f7931d",
                      padding: "8px 20px",
                      cursor: "pointer",
                      fontWeight: "600",
                      transition: "0.3s",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#f7931d";
                      e.target.style.color = "#fff";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "#efefef";
                      e.target.style.color = "#f7931d";
                    }}
                  >
                    Explore Now!
                  </button>
                </a>
              </div>
            </div>

            {/* Card 2 */}
            <div
              className="card"
              style={{
                textAlign: "center",
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "20px",
                transition: "0.3s",
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <div>
                <h6 style={{ fontWeight: "600", fontSize: "16px", marginBottom: "10px" }}>
                  <i className="bi bi-award" style={{ marginRight: "8px", color: "#f7931d" }}></i>
                  Private and International Scholarships
                </h6>
                <p style={{ fontSize: "14px", color: "#555", marginBottom: "15px" }}>
                  A portal to help you discover private and international scholarships.
                </p>
              </div>
              <div style={{ textAlign: "center" }}>
                <a href="UGCbot.html">
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#efefef",
                      fontSize: "14px",
                      border: "none",
                      borderRadius: "20px",
                      color: "#f7931d",
                      padding: "8px 20px",
                      cursor: "pointer",
                      fontWeight: "600",
                      transition: "0.3s",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#f7931d";
                      e.target.style.color = "#fff";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "#efefef";
                      e.target.style.color = "#f7931d";
                    }}
                  >
                    Explore Now!
                  </button>
                </a>
              </div>
            </div>

            {/* Card 3 */}
            <div
              className="card"
              style={{
                textAlign: "center",
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "20px",
                transition: "0.3s",
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <div>
                <h6 style={{ fontWeight: "600", fontSize: "16px", marginBottom: "10px" }}>
                  <i className="bi bi-tools" style={{ marginRight: "8px", color: "#f7931d" }}></i>
                  Vocational Training
                </h6>
                <p style={{ fontSize: "14px", color: "#555" }}>
                  A portal to help you discover vocational training programs.
                </p>
              </div>
              <div style={{ textAlign: "center" }}>
                <a href="https://www.nvq.gov.lk/Insreg_Home/insreg_Institute_Select_Search.php" target="_blank" rel="noopener noreferrer">
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#efefef",
                      fontSize: "14px",
                      border: "none",
                      borderRadius: "20px",
                      color: "#f7931d",
                      padding: "8px 20px",
                      cursor: "pointer",
                      fontWeight: "600",
                      transition: "0.3s",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#f7931d";
                      e.target.style.color = "#fff";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "#efefef";
                      e.target.style.color = "#f7931d";
                    }}
                  >
                    Explore Now!
                  </button>
                </a>
              </div>
            </div>

            {/* Card 4 */}
            <div
              className="card"
              style={{
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "20px",
                transition: "0.3s",
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <div>
                <h6 style={{ fontWeight: "600", fontSize: "16px", marginBottom: "10px" }}>
                  <i className="bi bi-lightbulb" style={{ marginRight: "8px", color: "#f7931d" }}></i>
                  AI-Guided Self Assessment
                </h6>
                <p style={{ fontSize: "14px", color: "#555", marginBottom: "15px" }}>
                  Future Lanka introduces Sri Lanka's first AI-guided self-assessment tool, helping
                  students swiftly and accurately identify their skills and passion.
                </p>
              </div>
              <div style={{ textAlign: "center" }}>
                <a href="https://passionbot.netlify.app/" target="_blank" rel="noopener noreferrer">
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#efefef",
                      fontSize: "14px",
                      border: "none",
                      borderRadius: "20px",
                      color: "#f7931d",
                      padding: "8px 20px",
                      cursor: "pointer",
                      fontWeight: "600",
                      transition: "0.3s",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#f7931d";
                      e.target.style.color = "#fff";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "#efefef";
                      e.target.style.color = "#f7931d";
                    }}
                  >
                    Ask Passion Igniter!
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* ======= Testimonials Section ======= */}
      <section id="testimonials" className="testimonials  "
        style={{ paddingTop: "0px" }}
      >
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2 style={{ fontSize: 'var(--fs-700)' }}>Testimonials</h2>
            <p style={{ fontSize: 'var(--fs-400)' }}>
              Discover the stories of those who have journeyed with us, sharing the impact and value of our work together.
            </p>
          </div>
          <div className="testimonials-slider swiper" data-aos="fade-up" data-aos-delay="100">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div className="testimonial-wrap">
                  <div className="testimonial-item">
                    <img src={testimonial3} className="testimonial-img" alt="Rev.Sister M.Nuwanthi" />
                    <h3>Rev.Sister M.Nuwanthi</h3>
                    <h4>Deputy Principal<br />Holy-Cross College,<br />Gampaha</h4>
                    <p>
                      <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                      Our heartfelt thanks to Future Lanka for the exceptional career and higher education guidance provided to our students. Their targeted support is crucial for shaping future ambitions, offering insights not found elsewhere. Future Lanka's dedication to solving key student challenges is admirable. We support their mission and look forward to their ongoing success.
                      <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="testimonial-wrap">
                  <div className="testimonial-item">
                    <img src={testimonial1} className="testimonial-img" alt="Sethmi Satnara" />
                    <h3>Sethmi Satnara</h3>
                    <h4>Student <br />Holy Cross College <br />Gampaha</h4>
                    <p>
                      <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                      I'm Sethmi Sathnara, and I was part of a Future Lanka Research and Development Foundation event aimed at guiding us towards making informed career choices in today's context. It was interactive and insightful. A big thank you to Future Lanka for their crucial support in shaping our career paths.
                      <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="testimonial-wrap">
                  <div className="testimonial-item">
                    <img src={testimonial4} className="testimonial-img" alt="K.Hiruna Budwin" />
                    <h3>K.Hiruna Budwin</h3>
                    <h4>A/L Student<br />Carey College, <br />Colombo 8.</h4>
                    <p>
                      <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                      FLRDF's guidance was a turning point for me.
                      Discovering my passion for Technology through their career services has set me on a promising path, and I'm grateful for the direction and support they've provided.
                      <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="testimonial-wrap">
                  <div className="testimonial-item">
                    <img src={testimonial5} className="testimonial-img" alt="Mrs. Niliena Feranando" />
                    <h3>Mrs. Niliena Feranando</h3>
                    <h4>Teacher<br />St. Peter's College,<br /> Colombo 04.</h4>
                    <p>
                      <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                      FLRDF has brought a fresh perspective to our teaching methods, emphasizing the importance of STEAM and real-world skills.
                      Their programs have not only enhanced our curriculum but also excited our students about their educational journeys.
                      <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="testimonial-wrap">
                  <div className="testimonial-item">
                    <img src={testimonial2} className="testimonial-img" alt="Kevin Weston" />
                    <h3>Kevin Weston</h3>
                    <h4>Student <br />St. Peters College <br />Colombo 04</h4>
                    <p>
                      <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                      I'm Kevin Weston from St. Peters College, honored to join Future Lanka Research and Development Foundation's consultation program. Their career guidance expertly navigated me through crucial career decisions at the advanced level. Thanks to Future Lanka's team for their pivotal role in my journey.
                      <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </section>






      {/* ======= Frequently Asked Questions Section ======= */}

      <section id="faq" className="faq">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2 style={{ fontSize: 'var(--fs-700)' }}>Frequently Asked Questions</h2>
          </div>
          <ul className="faq-list accordion" data-aos="fade-up" style={{ fontSize: 'var(--fs-400)' }}>
            {/* Example FAQ - Uncomment if needed */}
            {/* 
      <li>
        <a data-bs-toggle="collapse" className="collapsed" data-bs-target="#faq1">
          What is STEAM education, and why does it matter?
          <i className="bx bx-chevron-down icon-show"></i>
          <i className="bx bx-x icon-close"></i>
        </a>
        <div id="faq1" className="collapse" data-bs-parent=".faq-list">
          <p>
            STEAM stands for Science, Technology, Engineering, Arts, and Mathematics. 
            It matters because it integrates these critical areas into a cohesive 
            learning model based on real-world applications, encouraging creative 
            problem-solving and innovation.
          </p>
        </div>
      </li>
      */}

            <li>
              <a data-bs-toggle="collapse" data-bs-target="#faq2" className="collapsed" style={{ fontSize: '16px' }}>
                How can I get started with Future Lanka?
                <i className="bx bx-chevron-down icon-show"></i>
                <i className="bx bx-x icon-close"></i>
              </a>
              <div id="faq2" className="collapse" data-bs-parent=".faq-list">
                <p>
                  Getting started with Future Lanka is straightforward and convenient.
                  You can initiate your journey with us by either calling us directly,
                  sending us an email, or contacting us through our website. Once we receive
                  your inquiry, a dedicated team member will connect with you to schedule an
                  initial consultation. This important session allows us to understand your
                  aspirations, strengths, and requirements, enabling us to tailor our services
                  to best support your educational and career objectives. Reach out today to
                  begin shaping your future success with us.
                </p>
              </div>
            </li>

            <li>
              <a data-bs-toggle="collapse" data-bs-target="#faq3" className="collapsed" style={{ fontSize: '16px' }}>
                What can I expect from the Industry and Career Exploration service?
                <i className="bx bx-chevron-down icon-show"></i>
                <i className="bx bx-x icon-close"></i>
              </a>
              <div id="faq3" className="collapse" data-bs-parent=".faq-list">
                <p>
                  Expect a comprehensive exploration process that includes market analysis,
                  career trends forecasting, personal interest assessments, and professional
                  guidance to help align your skills and passions with the right industry
                  and career path for you.
                </p>
              </div>
            </li>

            <li>
              <a data-bs-toggle="collapse" data-bs-target="#faq4" className="collapsed" style={{ fontSize: '16px' }}>
                How does Higher Education Networking help me?
                <i className="bx bx-chevron-down icon-show"></i>
                <i className="bx bx-x icon-close"></i>
              </a>
              <div id="faq4" className="collapse" data-bs-parent=".faq-list">
                <p>
                  Our network includes a wide range of higher education institutions, both local
                  and international. We assist you in navigating this network to find programs
                  that match your career aspirations, provide application support, and offer
                  insights on scholarships and financial aid options.
                </p>
              </div>
            </li>

            <li>
              <a data-bs-toggle="collapse" data-bs-target="#faq5" className="collapsed" style={{ fontSize: '16px' }}>
                Can I arrange a session for our school?
                <i className="bx bx-chevron-down icon-show"></i>
                <i className="bx bx-x icon-close"></i>
              </a>
              <div id="faq5" className="collapse" data-bs-parent=".faq-list">
                <p>
                  Yes, we provide our services free of charge to over 300 schools annually
                  through our <strong>Career Guidance Awareness, Skill Development, and
                    STEM Education</strong> programs.
                </p>
                <p>
                  📞 <strong>Contact us to schedule a session for your school:</strong><br />
                  +94 70 454 0454 / +94 70 555 0454 <br />
                  +94 70 5550 454
                </p>
                <p>
                  📧 <strong>Email:</strong><br />
                  info@futurelanka.lk<br />
                  futurelanka2023@gmail.com
                </p>
              </div>
            </li>

            <li>
              <a data-bs-toggle="collapse" data-bs-target="#faq6" className="collapsed" style={{ fontSize: '16px' }}>
                Do you offer services for international students or professionals?
                <i className="bx bx-chevron-down icon-show"></i>
                <i className="bx bx-x icon-close"></i>
              </a>
              <div id="faq6" className="collapse" data-bs-parent=".faq-list">
                <p>
                  Yes, we provide guidance and support for international students and professionals
                  looking to study or work in Sri Lanka, as well as for Sri Lankan individuals
                  aiming to pursue opportunities abroad.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </section>



      {/* ======= Partners Section ======= */}
      <section id="clients" className="clients">
        <div className="container" data-aos="zoom-in">
          <div className="clients-slider swiper">
            <div className="swiper-wrapper align-items-center">
              {partnerLogos.map((file, idx) => (
                <div className="swiper-slide" key={idx}>
                  <img src={`/assets/img/Logos/${file}`} className="img-fluid partner-logo" alt={`Partner ${idx + 1}`} />
                </div>
              ))}
            </div>
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </section>


      <section id="contact-form" className="contact-form" style={{ backgroundColor: '#f8f9fa', color: '#333', padding: '80px 0' }}>
        <div className="container" data-aos="fade-up">
          <div className="section-title text-center mb-5">
            <h2 style={{ color: '#f7931d', fontSize: '2.5rem', marginBottom: '1rem' }}>Send Us a Message</h2>
            <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '0 auto' }}>
              Have a question or want to collaborate? Fill out the form below, and we'll get back to you promptly to discuss how we can work together.
            </p>
          </div>

          <div className="row justify-content-center" data-aos="fade-up" data-aos-delay="100">
            <div className="col-lg-5">
              <div className="contact-form-card p-4 rounded shadow-sm" style={{ backgroundColor: 'white', border: '2px solid #f7931d', borderRadius: '8px' }}>
                <h3 className="mb-4" style={{ color: '#f7931d' }}>Drop Us a Line</h3>

                {successMsg && (
                  <div className="alert alert-success" role="alert" style={{ fontSize: '14px', padding: '10px' }}>
                    {successMsg}
                  </div>
                )}
                {errorMsg && (
                  <div className="alert alert-danger" role="alert" style={{ fontSize: '14px', padding: '10px' }}>
                    {errorMsg}
                  </div>
                )}

                <form ref={formRef} onSubmit={handleSubmit}>
                  {/* Always-visible student form fields */}
                  <div className="mb-3">
                    <label className="form-label">First Name <span style={{ color: '#ef4444' }}>*</span></label>
                    <input type="text" className="form-control" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="Enter first name" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Last Name <span style={{ color: '#ef4444' }}>*</span></label>
                    <input type="text" className="form-control" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Enter last name" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Contact Number <span style={{ color: '#ef4444' }}>*</span></label>
                    <input type="tel" className="form-control" value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} placeholder="Enter contact number" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email <span style={{ color: '#ef4444' }}>*</span></label>
                    <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter email" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Message</label>
                    <textarea className="form-control" rows={4} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Enter your message (optional)"></textarea>
                  </div>

                  {/* Hidden fields for EmailJS */}
                  <input type="hidden" id="date" name="date" />
                  {/* Removed scholarship-related hidden fields */}

                  {/* Mirror inputs with names for EmailJS mapping */}
                  {/* These inputs are hidden but will mirror controlled values for sendForm */}
                  <input type="hidden" name="firstName" value={firstName} readOnly />
                  <input type="hidden" name="lastName" value={lastName} readOnly />
                  <input type="hidden" name="contactNumber" value={contactNumber} readOnly />
                  <input type="hidden" name="email" value={email} readOnly />
                  <input type="hidden" name="message" value={message} readOnly />

                  <button
                    type="submit"
                    className="btn w-100"
                    disabled={submitting}
                    style={{
                      backgroundColor: submitting ? '#bbb' : '#f7931d',
                      color: 'white',
                      fontSize: '14px',
                      padding: '10px',
                      borderRadius: '5px'
                    }}
                  >
                    {submitting ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ======= Contact Section ======= */}
      {/* <section id="contact" className="contact" style={{ backgroundColor: '#f8f9fa', color: '#333', padding: '80px 0' }}>
        <div className="container" data-aos="fade-up">
          <div className="section-title text-center mb-5">
            <h2 style={{ color: '#f7931d', fontSize: '2.5rem', marginBottom: '1rem' }}>Let's Connect!</h2>
            <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '0 auto' }}>
              Reach out to us through the contact details below or fill out our message form for a personalized response.
              Let's embark on this journey together, shaping a future filled with endless possibilities.
            </p>
          </div>

          <div className="row" data-aos="fade-up" data-aos-delay="100">
            <div className="col-lg-5 mb-4 mb-lg-0">
              <div className="contact-info-card p-4 rounded shadow-sm" style={{ backgroundColor: 'white', height: '100%' }}>
                <h3 className="mb-4" style={{ color: '#f7931d' }}>Get In Touch</h3>

                <div className="info-item d-flex mb-4">
                  <div className="icon-box me-3 d-flex align-items-center justify-content-center"
                    style={{ width: '50px', height: '50px', backgroundColor: '#f7931d', borderRadius: '50%' }}>
                    <i className="bx bx-map text-white" style={{ fontSize: '1.5rem' }}></i>
                  </div>
                  <div>
                    <h4>Address</h4>
                    <p>No. 16, Station Rd, Colombo 04</p>
                  </div>
                </div>

                <div className="info-item d-flex mb-4">
                  <div className="icon-box me-3 d-flex align-items-center justify-content-center"
                    style={{ width: '50px', height: '50px', backgroundColor: '#f7931d', borderRadius: '50%' }}>
                    <i className="bx bx-envelope text-white" style={{ fontSize: '1.5rem' }}></i>
                  </div>
                  <div>
                    <h4>Email Us</h4>
                    <p>info@futurelanka.lk<br />futurelanka2023@gmail.com</p>
                  </div>
                </div>

                <div className="info-item d-flex mb-4">
                  <div className="icon-box me-3 d-flex align-items-center justify-content-center"
                    style={{ width: '50px', height: '50px', backgroundColor: '#f7931d', borderRadius: '50%' }}>
                    <i className="bx bx-phone-call text-white" style={{ fontSize: '1.5rem' }}></i>
                  </div>
                  <div>
                    <h4>Call Us</h4>
                    <p>+94 70 454 0454 / +94 70 555 0454 <br />+94 70 5550 454</p>
                  </div>
                </div>

                <div className="text-center mt-4">
                  <p className="mb-2">Prefer to chat directly?</p>
                  <a aria-label="Chat on WhatsApp" href="https://wa.me/+94704540454" target="_blank" rel="noopener noreferrer"
                    className="btn btn-success d-inline-flex align-items-center"
                    style={{ padding: '10px 20px', borderRadius: '50px' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-whatsapp me-2" viewBox="0 0 16 16">
                      <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 极 1 1.928 4.66c-.004 3.639-2.961 6.592-极.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.极-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                    </svg>
                    Chat on WhatsApp
                  </a>
                </div>
              </div>
            </div>

      
            <div className="col-lg-7">
              <div className="map-container rounded shadow-sm overflow-hidden h-100">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.975398188572!2d79.85145337480938!3d6.8935459931055805!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae25b8a4c37ba7d%3A0x15814c194f3e0cf4!2sHomeTree%20Coworking!5e0!3m2!1sen!2slk!4v1712840643737!5m2!1sen!2slk"
                  width="100%"
                  height="100%"
                  style={{ border: '0', minHeight: '400px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="FLRDF Location Map"
                ></iframe>
              </div>
            </div>
          </div>


        </div>
      </section> */}



  

{/* ======= Modern Footer ======= */}
<footer id="footer" className="modern-footer">
  <div className="footer-main">
    <div className="container" style={{ maxWidth: "1200px", paddingLeft: "40px", paddingRight: "40px" }}>
      <div className="row gy-5">
        {/* Logo and Description */}
        <div className="col-lg-5 col-md-6">
          <div className="footer-brand">
            <img src={logoImg} alt="FLRDF Logo" className="footer-logo" />
            <h4 className="footer-brand-title">Future Lanka Research & Development Foundation</h4>
            <p className="footer-description">
              Empowering the next generation through innovative career guidance, 
              educational programs, and research initiatives across Sri Lanka.
            </p>
            <div className="social-links">
              <a href="https://web.facebook.com/FLRDFcommunity/?_rdc=1&_rdr" target="_blank" rel="noopener noreferrer" className="social-link facebook">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://youtube.com/@flrdfcommunity?si=6-r5ExjIbwDPK6qE" target="_blank" rel="noopener noreferrer" className="social-link youtube">
                <i className="bi bi-youtube"></i>
              </a>
              <a href="https://www.linkedin.com/company/future-lanka-research-and-development-foundation/" target="_blank" rel="noopener noreferrer" className="social-link linkedin">
                <i className="bi bi-linkedin"></i>
              </a>
              <a href="https://www.tiktok.com/@futurelanka?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer" className="social-link tiktok">
                <i className="bi bi-tiktok"></i>
              </a>
              <a href="https://www.instagram.com/flrdfcommunity/" target="_blank" rel="noopener noreferrer" className="social-link instagram">
                <i className="bi bi-instagram"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="col-lg-3 col-md-6">
          <div className="footer-section">
            <h5 className="footer-title">Quick Links</h5>
            <ul className="footer-links">
              <li><a href="index.html">Home</a></li>
              <li><a href="about.html">About Us</a></li>
              <li><a href="gallery.html">Gallery</a></li>
              <li><a href="index.html#services">Services</a></li>
              <li><a href="index.html#contact-form">Contact</a></li>
              <li><a href="index.html#faq">FAQs</a></li>
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="col-lg-4 col-md-6">
          <div className="footer-section">
            <h5 className="footer-title">Get in Touch</h5>
            <div className="contact-info">
              <div className="contact-item">
                <i className="bi bi-geo-alt-fill"></i>
                <div>
                  <span className="contact-label">Address</span>
                  <span className="contact-value">Bay 09, Trace Export City, Colombo 10, Sri Lanka</span>
                </div>
              </div>
              <div className="contact-item">
                <i className="bi bi-telephone-fill"></i>
                <div>
                  <span className="contact-label">Phone</span>
                  <span className="contact-value">+94 70 454 0454 / +94 70 555 0454 </span>
                </div>
              </div>
              <div className="contact-item">
                <i className="bi bi-envelope-fill"></i>
                <div>
                  <span className="contact-label">Email</span>
                  <span className="contact-value">info@futurelanka.lk</span>
                </div>
              </div>
            </div>
            <div className="whatsapp-btn">
              <a href="https://wa.me/+94704540454" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
                <i className="bi bi-whatsapp"></i>
                <span>Chat on WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Footer Bottom */}
  <div className="footer-bottom">
    <div className="container" style={{ maxWidth: "1200px", paddingLeft: "40px", paddingRight: "40px" }}>
      <div className="row align-items-center">
        <div className="col-md-6">
          <p className="copyright">
            &copy; {new Date().getFullYear()} <strong>FLRDF</strong>. All Rights Reserved
          </p>
        </div>
        <div className="col-md-6 text-md-end">
          <p className="developer">
            Designed & Developed by <a href="https://www.linkedin.com/in/vinuki-thomasz-8199b1225/" target="_blank" className="developer-link">Vinuki Thomasz</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>

{/* Modern Footer Styles */}
<style jsx>{`
  /* Modern Footer Styles */
  .modern-footer {
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
    color: #ffffff;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    position: relative;
    overflow: hidden;
  }

  .modern-footer::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #ea580c, #f97316, #ea580c);
    background-size: 200% 100%;
    animation: gradient-shift 3s ease infinite;
  }

  .footer-main {
    padding: 25px 0 15px;
    position: relative;
    z-index: 2;
  }

  .footer-brand {
    margin-bottom: 15px;
  }

  .footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
    margin-bottom: 10px;
    filter: brightness(1.2);
  }

  .footer-brand-title {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 8px;
    background: linear-gradient(135deg, #ea580c, #f97316);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .footer-description {
    color: #b0b0b0;
    line-height: 1.4;
    margin-bottom: 15px;
    font-size: 12px;
  }

  .social-links {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  .social-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    text-decoration: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .social-link:hover {
    transform: translateY(-3px) scale(1.1);
    color: #ffffff;
    text-decoration: none;
  }

  .social-link.facebook:hover {
    background: #1877f2;
    box-shadow: 0 8px 25px rgba(24, 119, 242, 0.4);
  }

  .social-link.youtube:hover {
    background: #ff0000;
    box-shadow: 0 8px 25px rgba(255, 0, 0, 0.4);
  }

  .social-link.linkedin:hover {
    background: #0a66c2;
    box-shadow: 0 8px 25px rgba(10, 102, 194, 0.4);
  }

  .social-link.tiktok:hover {
    background: #25f4ee;
    box-shadow: 0 8px 25px rgba(37, 244, 238, 0.4);
  }

  .social-link.instagram:hover {
    background: #e4405f;
    box-shadow: 0 8px 25px rgba(228, 64, 95, 0.4);
  }

  .footer-section {
    margin-bottom: 15px;
  }

  .footer-title {
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 12px;
    position: relative;
    padding-bottom: 6px;
  }

  .footer-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 30px;
    height: 2px;
    background: linear-gradient(90deg, #ea580c, #f97316);
    border-radius: 1px;
  }

  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .footer-links li {
    margin-bottom: 6px;
  }

  .footer-links a {
    color: #b0b0b0;
    text-decoration: none;
    font-size: 13px;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 0;
  }

  .footer-links a::before {
    content: '';
    position: absolute;
    left: -15px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 2px;
    background: linear-gradient(90deg, #ea580c, #f97316);
    transition: width 0.3s ease;
  }

  .footer-links a:hover {
    color: #ffffff;
    padding-left: 15px;
    text-decoration: none;
  }

  .footer-links a:hover::before {
    width: 10px;
  }

  .contact-info {
    margin-bottom: 15px;
  }

  .contact-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 8px;
    padding: 8px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
  }

  .contact-item:hover {
    background: rgba(255, 255, 255, 0.08);
    transform: translateX(5px);
  }

  .contact-item i {
    font-size: 18px;
    color: #ea580c;
    margin-right: 12px;
    margin-top: 2px;
    flex-shrink: 0;
  }

  .contact-item div {
    display: flex;
    flex-direction: column;
  }

  .contact-label {
    font-size: 11px;
    color: #ea580c;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 3px;
  }

  .contact-value {
    font-size: 13px;
    color: #ffffff;
    font-weight: 500;
  }

  .whatsapp-button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, #25d366, #128c7e);
    color: #ffffff;
    padding: 10px 20px;
    border-radius: 50px;
    text-decoration: none;
    font-weight: 600;
    font-size: 13px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3);
    border: none;
  }

  .whatsapp-button:hover {
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
    color: #ffffff;
    text-decoration: none;
  }

  .whatsapp-button i {
    font-size: 18px;
  }

  .footer-bottom {
    background: rgba(0, 0, 0, 0.3);
    padding: 10px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  .copyright {
    color: #b0b0b0;
    font-size: 13px;
    margin: 0;
  }

  .developer {
    color: #b0b0b0;
    font-size: 13px;
    margin: 0;
  }

  .developer-link {
    color: #ea580c;
    text-decoration: none;
    font-weight: 600;
    transition: color 0.3s ease;
  }

  .developer-link:hover {
    color: #f97316;
    text-decoration: none;
  }

  @keyframes gradient-shift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }

  @media (max-width: 768px) {
    .footer-main {
      padding: 20px 0 15px;
    }

    .footer-brand-title {
      font-size: 14px;
    }

    .footer-description {
      font-size: 11px;
    }

    .social-links {
      gap: 8px;
    }

    .social-link {
      width: 35px;
      height: 35px;
    }

    .contact-item {
      padding: 6px;
    }

    .whatsapp-button {
      padding: 8px 16px;
      font-size: 12px;
    }
  }
`}</style>


      {/* ======= Chatbot Toggle Button and Widget ======= */}
      <div className="chatbot-container">
        <button
          onClick={toggleChatbot}
          className="chatbot-toggle-btn robot-glow"
        >
          <div className="chatbot-content">
            <span className="chatbot-text">UGC</span>
            <i className="bi bi-robot"></i>
          </div>
          <span className="chatbot-tooltip">UGC Course Guide Bot</span>
        </button>
        <div className="chatbot-widget" style={{ display: isChatbotOpen ? 'block' : 'none' }}>
          <Chatbot onClose={() => setIsChatbotOpen(false)} />
        </div>
      </div>

      {/* Comprehensive Responsive Chatbot Styles */}
      <style jsx>{`
        /* Chatbot Container */
        .chatbot-container {
          position: fixed;
          bottom: 15px;
          right: 20px;
          z-index: 1000;
          padding-right: 50px;
        }

        /* Chatbot Toggle Button */
        .chatbot-toggle-btn {
          background: linear-gradient(135deg, #f7931d, #ff6b35);
          color: white;
          border: none;
          border-radius: 50%;
          width: 70px;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 28px;
          box-shadow: 0 0 0 6px rgba(247, 147, 30, 0.4), 0 0 0 12px rgba(247, 147, 30, 0.2), 0 0 0 18px rgba(247, 147, 30, 0.1), 0 15px 35px rgba(247, 147, 30, 0.5);
          transition: all 0.3s ease;
          animation: pulseGlow 2.4s ease-in-out infinite;
          position: relative;
        }

        /* Chatbot Content Layout */
        .chatbot-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 2px;
        }

        /* UGC Text */
        .chatbot-text {
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.5px;
          line-height: 1;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        }

        .chatbot-toggle-btn:hover {
          transform: translateY(-3px) scale(1.08);
          box-shadow: 0 0 0 8px rgba(247, 147, 30, 0.5), 0 0 0 16px rgba(247, 147, 30, 0.3), 0 0 0 24px rgba(247, 147, 30, 0.15), 0 20px 45px rgba(247, 147, 30, 0.6);
        }

        /* Chatbot Tooltip */
        .chatbot-tooltip {
          position: absolute;
          bottom: 90px;
          right: -10px;
          background: linear-gradient(135deg, rgba(26, 26, 26, 0.6), rgba(45, 45, 45, 0.5));
          color: white;
          padding: 12px 18px;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          white-space: nowrap;
          opacity: 0;
          visibility: hidden;
          transform: translateY(15px) scale(0.9);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          z-index: 1001;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.15);
        }

        .chatbot-tooltip::after {
          content: '';
          position: absolute;
          top: 100%;
          right: 25px;
          border: 6px solid transparent;
          border-top-color: rgba(26, 26, 26, 0.6);
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
        }

        .chatbot-toggle-btn:hover .chatbot-tooltip {
          opacity: 1;
          visibility: visible;
          transform: translateY(0) scale(1);
        }

        /* Chatbot Widget */
        .chatbot-widget {
          position: absolute;
          bottom: 80px;
          right: 0;
          width: 600px;
          max-width: 95vw;
          box-shadow: none;
          border-radius: 0;
          overflow: visible;
          background: transparent;
        }

        /* Responsive Chatbot Positioning */
        @media (max-width: 768px) {
          .chatbot-container {
            bottom: 10px;
            right: 15px;
            padding-right: 30px;
          }
          
          .chatbot-toggle-btn {
            width: 65px;
            height: 65px;
            font-size: 24px;
          }
          
          .chatbot-text {
            font-size: 9px;
          }
          
          .chatbot-tooltip {
            font-size: 13px;
            padding: 10px 15px;
            bottom: 85px;
            right: -5px;
          }
          
          .chatbot-widget {
            width: 90vw;
            max-width: 400px;
            bottom: 85px;
            right: -10px;
          }
        }

        @media (max-width: 480px) {
          .chatbot-container {
            bottom: 5px;
            right: 10px;
            padding-right: 20px;
          }
          
          .chatbot-toggle-btn {
            width: 60px;
            height: 60px;
            font-size: 22px;
          }
          
          .chatbot-text {
            font-size: 8px;
          }
          
          .chatbot-tooltip {
            font-size: 12px;
            padding: 8px 12px;
            bottom: 80px;
            right: -3px;
          }
          
          .chatbot-widget {
            width: 95vw;
            max-width: 350px;
            bottom: 80px;
            right: -15px;
          }
        }

        @media (max-width: 320px) {
          .chatbot-container {
            bottom: 3px;
            right: 8px;
            padding-right: 15px;
          }
          
          .chatbot-toggle-btn {
            width: 55px;
            height: 55px;
            font-size: 20px;
          }
          
          .chatbot-text {
            font-size: 7px;
          }
          
          .chatbot-tooltip {
            font-size: 11px;
            padding: 6px 10px;
            bottom: 75px;
            right: -2px;
          }
          
          .chatbot-widget {
            width: 98vw;
            max-width: 300px;
            bottom: 75px;
            right: -20px;
          }
        }

        /* Pulse Animation */
        @keyframes pulseGlow {
          0% { box-shadow: 0 0 0 6px rgba(247,147,30,0.40), 0 0 0 12px rgba(247,147,30,0.20), 0 0 0 18px rgba(247,147,30,0.10), 0 15px 35px rgba(247,147,30,0.50); }
          50% { box-shadow: 0 0 0 12px rgba(247,147,30,0.30), 0 0 0 24px rgba(247,147,30,0.15), 0 0 0 36px rgba(247,147,30,0.08), 0 20px 45px rgba(247,147,30,0.70); }
          100% { box-shadow: 0 0 0 6px rgba(247,147,30,0.40), 0 0 0 12px rgba(247,147,30,0.20), 0 0 0 18px rgba(247,147,30,0.10), 0 15px 35px rgba(247,147,30,0.50); }
        }

        /* Additional Responsive Improvements */
        @media (max-width: 768px) {
          .container {
            padding-left: 15px !important;
            padding-right: 15px !important;
          }
          
          .section-title h2 {
            font-size: 24px !important;
          }
          
          .section-title p {
            font-size: 14px !important;
          }
        }

        @media (max-width: 480px) {
          .container {
            padding-left: 10px !important;
            padding-right: 10px !important;
          }
          
          .section-title h2 {
            font-size: 22px !important;
          }
          
          .section-title p {
            font-size: 13px !important;
          }
        }

        /* Touch-friendly improvements */
        @media (hover: none) and (pointer: coarse) {
          .chatbot-toggle-btn:hover {
            transform: none;
          }
          
          .card:hover {
            transform: none !important;
          }
          
          .btn-get-started:hover {
            transform: none;
          }
        }

        /* Partner Logos Styling */
        .partner-logo {
          max-height: 160px !important;
          min-height: 100px !important;
          max-width: 220px !important;
          min-width: 130px !important;
          width: auto !important;
          object-fit: contain;
          filter: grayscale(100%);
          opacity: 0.7;
          transition: all 0.3s ease;
        }

        .partner-logo:hover {
          filter: grayscale(0%);
          opacity: 1;
          transform: scale(1.1);
        }

        .clients-slider .swiper-slide {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 180px;
          width: 280px;
          padding: 18px;
        }

        /* Responsive partner logos */
        @media (max-width: 768px) {
          .partner-logo {
            max-height: 130px !important;
            min-height: 85px !important;
            max-width: 180px !important;
            min-width: 110px !important;
          }
          
          .clients-slider .swiper-slide {
            height: 150px;
            width: 230px;
            padding: 13px;
          }
        }

        @media (max-width: 480px) {
          .partner-logo {
            max-height: 110px !important;
            min-height: 70px !important;
            max-width: 140px !important;
            min-width: 90px !important;
          }
          
          .clients-slider .swiper-slide {
            height: 130px;
            width: 180px;
            padding: 10px;
          }
        }

        /* Landscape orientation adjustments */
        @media (max-height: 500px) and (orientation: landscape) {
          .hero-carousel-section {
            height: 100vh;
          }
          
          .hero-title {
            font-size: 2rem !important;
          }
          
          .hero-subtitle {
            font-size: 1rem !important;
          }
        }
      `}</style>

      <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
    </div>
  );
};

export default Home;